
import React from 'react';
import { Leaf, Sun, Snowflake } from 'lucide-react';

interface ServiceLocalContentProps {
  localContent: {
    intro: string;
    regionalBenefits: string[];
    seasonalTips: string[];
  };
  serviceName: string;
}

const ServiceLocalContent = ({ localContent, serviceName }: ServiceLocalContentProps) => {
  if (!localContent) return null;

  const seasonIcons = [
    { icon: Leaf, color: 'text-green-600', bg: 'bg-green-100' },
    { icon: Sun, color: 'text-yellow-600', bg: 'bg-yellow-100' },
    { icon: Leaf, color: 'text-orange-600', bg: 'bg-orange-100' },
    { icon: Snowflake, color: 'text-blue-600', bg: 'bg-blue-100' }
  ];

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Regional Intro */}
          <div className="mb-12">
            <h2 className="text-2xl font-serif font-bold text-pkstone-900 mb-4">
              {serviceName} in Connecticut
            </h2>
            <p className="text-pkstone-600 text-lg leading-relaxed">
              {localContent.intro}
            </p>
          </div>

          {/* Regional Benefits */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            <div>
              <h3 className="text-xl font-serif font-bold text-pkstone-900 mb-4">
                Why Choose Local Expertise
              </h3>
              <ul className="space-y-3">
                {localContent.regionalBenefits.map((benefit, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-pkgreen-600 rounded-full mt-2 flex-shrink-0"></div>
                    <span className="text-pkstone-700">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Seasonal Tips */}
            <div>
              <h3 className="text-xl font-serif font-bold text-pkstone-900 mb-4">
                Seasonal Considerations
              </h3>
              <div className="space-y-3">
                {localContent.seasonalTips.map((tip, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className={`p-1.5 rounded ${seasonIcons[index % 4].bg} flex-shrink-0`}>
                      {React.createElement(seasonIcons[index % 4].icon, {
                        className: `h-4 w-4 ${seasonIcons[index % 4].color}`
                      })}
                    </div>
                    <span className="text-pkstone-700 text-sm">{tip}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceLocalContent;
